import React, {Component} from 'react'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import Button from '@mui/material/Button'
import Select from '@mui/material/Select'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Alert from '@mui/lab/Alert'
import ExcelJS from 'exceljs'
import FileSaver from 'file-saver'


import DepositosTable from './DepositosTable'
import LineChartSvg, { formatCompact } from './LineChartSvg'
import { AlertTitle, Collapse, Grid, Paper, Snackbar } from '@mui/material'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
import PaidRoundedIcon from '@mui/icons-material/PaidRounded'
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded'

const {DateTime} = require('luxon')
const session = require('../../config/session')
const RestTunel = require('../../libs/rest_tunnel')

function StatBox({ icon, color, label, value }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: '14px',
        border: '1px solid rgba(0,0,0,0.06)',
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        backgroundColor: '#fff',
        minHeight: 76,
      }}
    >
      <Box
        sx={{
          width: 46,
          height: 46,
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: `${color}1A`,
          color,
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          variant="caption"
          sx={{ color: '#666', textTransform: 'uppercase', letterSpacing: '0.06em', fontWeight: 600 }}
        >
          {label}
        </Typography>
        <Typography variant="h5" sx={{ fontWeight: 800, color: '#222', lineHeight: 1.1 }} noWrap>
          {value}
        </Typography>
      </Box>
    </Paper>
  )
}

class DepositosPage extends Component {

  constructor() {
    super()

    var fechaFinTemp = DateTime.local().set({hour: 23, minute: 59, second: 59})

      this.state = {
      paises: [],
      entidades: [],
      cajeros: [],
      grupos: [],
      depositos: [],
      clientes: [],

      mostrarAlerta: false,
      mensajeAlerta: '',
      severidadAlerta: 'info',
      filtroFechaInicio: null,
      filtroFechaFin: fechaFinTemp
    };

    this.btnBucarClick = this.btnBucarClick.bind(this)

    this.cmbGrupos = React.createRef()
    this.cmbPaises = React.createRef()
    this.cmbCajeros = React.createRef()
    this.cmbEntidades = React.createRef()
    this.cmbClientes = React.createRef()
    this.txtAprobacion = React.createRef()

    this.exportExcel = this.exportExcel.bind(this)

    this.filtroFechaInicio = ""
    this.filtroFechaFin = ""
  }

  fechaFiltroChanged(origen, date) {
    if (date == null) return

    var formatoFechaInicio = "yyyy-LL-dd HH:mm:00"
    var formatoFechaFin = "yyyy-LL-dd HH:mm:59"

    switch (origen) {
      case 'inicio':
        this.setState({
          filtroFechaInicio: date
        })
        this.filtroFechaInicio = date.toFormat(formatoFechaInicio)
        break;
      case 'fin':
        this.setState({
          filtroFechaFin: date
        })
        this.filtroFechaFin = date.toFormat(formatoFechaFin)
        break;
      default:

    }
  }

  btnBucarClick() {
    this.queryDepositos()
  } 

  handleCloseAlert= (event, reason) => {
    if (reason === 'clickaway') {
      return; // Evitar que se cierre si el usuario hace clic fuera
    }
    this.setState({ mostrarAlerta: false })
  }

  queryEntidades() {
        
    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/entidades/usuario/list'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        // alert("Error consultando entidades")
        // console.log('Error respuesta consultando entidades')
        this.setState({
          entidades: [],
          mensajeError: data.message,
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando entidades',
          severidadAlerta: 'error'
        })
      } else {
      	this.setState({
        	entidades: data
        })
      }
    })
  }

  queryGrupos() {       
    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/usuarios/grupos/list'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        // alert("Error consultando grupos")
        //console.log('Error respuesta consultando grupos')
        this.setState({
          grupos: [],
          mensajeError: data.message,
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando grupos',
          severidadAlerta: 'error'
        })
      } else {
        //console.log('Grupos consultados')
      	this.setState({
        	grupos: data
        })
      }
    })
  }

  queryPaises() {
    // console.log('Consultando paises....')

	var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/paises/'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        //alert("Error consultando paises")
        // console.log('Error respuesta consultando paises')
        this.setState({
          paises: [],
          mensajeError: data.message,
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando paises',
          severidadAlerta: 'error'
        })
      } else {
        //console.log('Paises consultados')
      	this.setState({
        	paises: data
        })
      }
    })
  }

  queryCajeros() {

     var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/usuarios/cajerosconsultas/list'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        //alert("Error consultando cajeros")
        //console.log('Error respuesta consultando cajeros')
        this.setState({
          cajeros: [],
          mensajeError: data.message,
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando cajeros',
          severidadAlerta: 'error'
        })
      } else {
        // console.log('Cajeros consultados')
      	this.setState({
        	cajeros: data
        })
      }
    })
    
   }



   queryClientes() {
     var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/clientes/list'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        //alert("Error consultando cajeros")
        //console.log('Error respuesta consultando cajeros')
        this.setState({
          clientes: [],
          mensajeError: data.message,
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando cajeros',
          severidadAlerta: 'error'
        })
      } else {
        // console.log('Cajeros consultados')
      	this.setState({
        	clientes: data
        })
      }
    })
    
   }


  queryDepositos() {

    var filtroIdPais = ''
    var filtroIdGrupo = ''
    var filtroIdCajero = ''
    var filtroIdEntidad = ''
    var filtroIdCliente = ''
    var filtroAprobacion = ''

	/*
    if(this.cmbPaises.current.value > 0){
      filtroIdPais = this.cmbPaises.current.value
    }
    */

    if(this.cmbGrupos.current.value !== 0){
      filtroIdGrupo = this.cmbGrupos.current.value
    }

    if(this.cmbCajeros.current.value !== 0){
      filtroIdCajero = this.cmbCajeros.current.value
    }
    
    if(this.cmbEntidades.current.value !== 0){
      filtroIdEntidad = this.cmbEntidades.current.value
    }

    if(this.cmbClientes.current.value !== 0){
      filtroIdCliente = this.cmbClientes.current.value
    }

    filtroAprobacion = this.txtAprobacion.current.value.toString()
    
    if(filtroIdGrupo === '' && filtroIdCajero === '') {
      //alert("Debe seleccionar un grupo o un cajero")
      this.setState({
        mostrarAlerta: true,
        mensajeAlerta: 'Debe seleccionar un grupo o un cajero',
        severidadAlerta: 'warning'
      })
      return
    }

	  var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {
		    filtro_id_pais: filtroIdPais,
        filtro_id_grupo: filtroIdGrupo,
        filtro_id_cajero: filtroIdCajero,
        filtro_id_entidad: filtroIdEntidad,
        filtro_id_cliente: filtroIdCliente,
        filtro_fecha_inicio: this.filtroFechaInicio,
        filtro_fecha_fin: this.filtroFechaFin,
        filtro_aprobacion: filtroAprobacion,
		},
      url: process.env.REACT_APP_URL_BACKEND + '/depositos/list'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        //alert("Error consultando depositos")
        // console.log('Error respuesta consultando depositos')
        this.setState({
          depositos: [],
          mensajeError: data.message,
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando depositos',
          severidadAlerta: 'error'
        })
      } else {
        //console.log('Depositos consultados')
      	this.setState({
        	depositos: data
        })
      }
    })

   }


   calcularSuma = (detalleAlerta) => {
    const piezasBilletes = {
        1000: 0,
        2000: 0,
        5000: 0,
        10000: 0,
        20000: 0,
        50000: 0,
        100000: 0
    };

    const valorBilletes = {
        1000: 0,
        2000: 0,
        5000: 0,
        10000: 0,
        20000: 0,
        50000: 0,
        100000: 0
    };

    const monedas = {
        20: 0,
        50: 0,
        100: 0,
        200: 0,
        500: 0,
        1000: 0,
    };

    try {
        const { currencies = [] } = JSON.parse(detalleAlerta || '{}').automatico || {};

        currencies.forEach(({ bills = [] }) => {
            bills.forEach(({ denomination, amount }) => {
                const denom = Number(denomination);
                if (piezasBilletes.hasOwnProperty(denom)) {
                    const cantidad = Number(amount || 0);
                    piezasBilletes[denom] += cantidad;
                    valorBilletes[denom] += cantidad * denom;
                }
            });
        });

        currencies.forEach(({ coins = [] }) => {
            coins.forEach(({ denomination, amount }) => {
                const denom = Number(denomination);
                if (monedas.hasOwnProperty(denom)) {
                    monedas[denom] += Number(amount || 0) * denom;
                }
            });
        });
    } catch (error) {
        console.error("Error procesando alerta:", error);
    }

    return {
        PIEZAS_BILL_1000: piezasBilletes[1000],
        VALOR_BILL_1000: valorBilletes[1000],
        PIEZAS_BILL_2000: piezasBilletes[2000],
        VALOR_BILL_2000: valorBilletes[2000],
        PIEZAS_BILL_5000: piezasBilletes[5000],
        VALOR_BILL_5000: valorBilletes[5000],
        PIEZAS_BILL_10000: piezasBilletes[10000],
        VALOR_BILL_10000: valorBilletes[10000],
        PIEZAS_BILL_20000: piezasBilletes[20000],
        VALOR_BILL_20000: valorBilletes[20000],
        PIEZAS_BILL_50000: piezasBilletes[50000],
        VALOR_BILL_50000: valorBilletes[50000],
        PIEZAS_BILL_100000: piezasBilletes[100000],
        VALOR_BILL_100000: valorBilletes[100000],
    };
  };


    exportExcel() {
      
      var workbook = new ExcelJS.Workbook()
      var sheet = workbook.addWorksheet("Depositos")

      var nombreArchivo = 'Depositos.xlsx'

      var headers = [
        {header: 'Fecha Registro'},
        {header: 'Codigo Cajero'},
        {header: 'Tipo transaccion'},
        {header: 'Alias Cajero'},
        {header: 'Entidad'},
        {header: 'Depositante'},
        {header: 'ID Depositante'},
        {header: 'Valor Total'},
        {header: 'Moneda'},
        {header: 'Finalizacion'},
        {header: 'Aprobacion'},
        {header: 'Fecha Recaudo'},
        {header: "PIEZAS_BILL_1000", key: 'PIEZAS_BILL_1000'},
        {header: "VALOR_BILL_1000", key: 'VALOR_BILL_1000'},
        {header: "PIEZAS_BILL_2000", key: 'PIEZAS_BILL_2000'},
        {header: "VALOR_BILL_2000", key: 'VALOR_BILL_2000'},
        {header: "PIEZAS_BILL_5000", key: 'PIEZAS_BILL_5000'},
        {header: "VALOR_BILL_5000", key: 'VALOR_BILL_5000'},
        {header: "PIEZAS_BILL_10000", key: 'PIEZAS_BILL_10000'},
        {header: "VALOR_BILL_10000", key: 'VALOR_BILL_10000'},
        {header: "PIEZAS_BILL_20000", key: 'PIEZAS_BILL_20000'},
        {header: "VALOR_BILL_20000", key: 'VALOR_BILL_20000'},
        {header: "PIEZAS_BILL_50000", key: 'PIEZAS_BILL_50000'},
        {header: "VALOR_BILL_50000", key: 'VALOR_BILL_50000'},
        {header: "PIEZAS_BILL_100000", key: 'PIEZAS_BILL_100000'},
        {header: "VALOR_BILL_100000", key: 'VALOR_BILL_100000'},
        {header: "Rechazados", key: 'rechazados'},

      ]
      sheet.columns = headers


      var records = this.state.depositos
      records.forEach((item) => {
        const sumas = this.calcularSuma(item.detalle);
        var row = [
          item.fecha_registro,
          item.codigo_cajero,
          item.TipoTransaccion,
          item.alias_cajero,
          item.entidad,
          item.nombre_cliente,
          item.referencia_pago,
          item.valor,
          item.moneda,
          item.finalizacion,
          item.aprobacion,
          item.fecha_recaudo,
          sumas.PIEZAS_BILL_1000,
          sumas.VALOR_BILL_1000,
          sumas.PIEZAS_BILL_2000,
          sumas.VALOR_BILL_2000,
          sumas.PIEZAS_BILL_5000,
          sumas.VALOR_BILL_5000,
          sumas.PIEZAS_BILL_10000,
          sumas.VALOR_BILL_10000,
          sumas.PIEZAS_BILL_20000,
          sumas.VALOR_BILL_20000,
          sumas.PIEZAS_BILL_50000,
          sumas.VALOR_BILL_50000,
          sumas.PIEZAS_BILL_100000,
          sumas.VALOR_BILL_100000,
          item.rechazados ?? '',
        ]
        sheet.addRow(row)
      })
   
      workbook.xlsx.writeBuffer().then((data) => {
        FileSaver.saveAs(new Blob([data]), nombreArchivo)
      
        this.setState({
          mostrarAlerta: true,
          mensajeAlerta: 'Archivo generado',
          severidadAlerta: 'success'
        })
      })
    }

    computeStatsYSeries() {
      const depositos = this.state.depositos || []
      const cantidad = depositos.length
      // tipo_transaccion === 100 -> "Automatico" (billetero); resto -> "Sobre"
      const totalBilletero = depositos.reduce((acc, d) => acc + (Number(d.tipo_transaccion) === 100 ? (Number(d.valor) || 0) : 0), 0)
      const totalSobre = depositos.reduce((acc, d) => acc + (Number(d.tipo_transaccion) !== 100 ? (Number(d.valor) || 0) : 0), 0)
      const rechazos = depositos.reduce((acc, d) => acc + (Number(d.rechazados) || 0), 0)
      const monedas = Array.from(new Set(depositos.map(d => d.moneda).filter(Boolean)))
      const moneda = monedas.length === 1 ? monedas[0] : ''

      // La tendencia por día considera solo depósitos por billetero (Automatico).
      const porDia = {}
      depositos.forEach(d => {
        if (Number(d.tipo_transaccion) !== 100) return
        if (!d.fecha_registro) return
        const iso = String(d.fecha_registro).slice(0, 10)
        if (!porDia[iso]) porDia[iso] = { count: 0, total: 0 }
        porDia[iso].count += 1
        porDia[iso].total += Number(d.valor) || 0
      })
      const dias = Object.keys(porDia).sort()
      const labels = dias.map(iso => {
        const dt = DateTime.fromISO(iso)
        return dt.isValid ? dt.toFormat('dd/LL') : iso
      })
      const counts = dias.map(iso => porDia[iso].count)
      const totals = dias.map(iso => porDia[iso].total)

      return { cantidad, totalBilletero, totalSobre, rechazos, moneda, labels, counts, totals }
    }

    componentDidMount() {
      this.queryGrupos()
      this.queryPaises()
      this.queryCajeros()
      this.queryEntidades()
      this.queryClientes()
      //this.queryDepositos()
    }

  render() {
    return (
      <Box>
        <Typography gutterBottom variant="h5" component="div" sx={{ marginBottom: 2 }}>
          Depositos 
        </Typography>

        <Paper elevation={16}>
          <Card>
            <CardContent>

              <Typography gutterBottom variant="h6" component="div">
                  Buscar depositos:
              </Typography>

              <Grid container spacing={2} sx={{marginTop: 1}}>
                <Grid item xs={3}>
                  <LocalizationProvider dateAdapter={AdapterLuxon}>
                    <DateTimePicker
                        inputFormat="dd/MM/yyyy HH:mm"
                      label="Fecha/Hora Inicio"
                      value={this.state.filtroFechaInicio}
                      onChange={date => this.fechaFiltroChanged('inicio', date)}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={3}>
                  <LocalizationProvider dateAdapter={AdapterLuxon}>
                    <DateTimePicker
                        inputFormat="dd/MM/yyyy HH:mm"
                      label="Fecha/Hora fin"
                      value={this.state.filtroFechaFin}
                      onChange={date => this.fechaFiltroChanged('fin', date)}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>

                </Grid>
                <Grid item xs={3}>
                  <FormControl>
                    <TextField
                      label="Codigo de Aprobacion"
                      id="outlined-basic"
                      variant="outlined"
                      inputRef={this.txtAprobacion}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={3}>
                  <FormControl sx={{visibility: 'hidden'}}>
                    <InputLabel>Pais</InputLabel>
                    <Select style={{width: 0}}
                      label="Entidad"
                      inputRef={this.cmbPaises}
                      defaultValue={0}>
                      <MenuItem value={0}>-- Seleccione --</MenuItem>
                      {this.state.paises.map(pais => (
                        <MenuItem key={pais.id} value={pais.id}>{pais.nombre}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{marginTop: 1}}>
                <Grid item xs={3}>
                  <FormControl>
                    <InputLabel>Grupo</InputLabel>
                    <Select style={{width: 200}}
                      label="Entidad"
                      inputRef={this.cmbGrupos}
                      defaultValue={0}>
                      <MenuItem value={0}>-- Seleccione --</MenuItem>
                      {this.state.grupos.map(grupo => (
                        <MenuItem key={grupo.id} value={grupo.id}>{grupo.nombre}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={3}>
                  <FormControl>
                    <InputLabel>Cajero</InputLabel>
                    <Select style={{width: 200}}
                      label="Cajero"
                      inputRef={this.cmbCajeros}
                      defaultValue={0}>
                      <MenuItem value={0}>-- Seleccione --</MenuItem>
                      {this.state.cajeros.map(cajero => (
                        <MenuItem key={cajero.id} value={cajero.id}>{cajero.alias}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={3}>
                  <FormControl>
                    <InputLabel>Entidad</InputLabel>
                    <Select style={{width: 200}}
                      label="Entidad"
                      inputRef={this.cmbEntidades}
                      defaultValue={0}>
                      <MenuItem value={0}>-- Todas --</MenuItem>
                      {this.state.entidades.map(entidad => (
                        <MenuItem key={entidad.id} value={entidad.id}>{entidad.nombre}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={3}>
                  <FormControl>
                    <InputLabel>Depositante</InputLabel>
                    <Select style={{width: 200}}
                      label="Depositante"
                      inputRef={this.cmbClientes}
                      defaultValue={0}>
                      <MenuItem value={0}>-- Todas --</MenuItem>
                      {this.state.clientes.map(cliente => (
                        <MenuItem key={cliente.id} value={cliente.id}>{cliente.nombre}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>                
              </Grid>

            </CardContent>

            <CardActions>
              <Button variant="contained" size="large" onClick={this.btnBucarClick}>Buscar</Button>
              <Snackbar
                                open={this.state.mostrarAlerta}
                                onClose={this.handleCloseAlert}
                                autoHideDuration={3000}
                                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                              >
                                <Collapse in={this.state.mostrarAlerta}>
                                    <Alert
                                          severity={this.state.severidadAlerta}
                                          onClose={this.handleCloslert}
                                          sx={{ marginTop: 4, width:'100%'}}
                                              >
                                    <AlertTitle>
                                      {this.state.severidadAlerta.toUpperCase()}
                                    </AlertTitle>
                                       {this.state.mensajeAlerta}
                                    </Alert>
                                </Collapse>
              </Snackbar>
            </CardActions>
          </Card>
        </Paper>

        {(() => {
          const { cantidad, totalBilletero, totalSobre, rechazos, moneda, labels, counts, totals } = this.computeStatsYSeries()
          if (cantidad === 0) return null
          const fmtCount = (v) => Number(v).toLocaleString('es-CO')
          const fmtMoneda = (v) => '$' + Number(v).toLocaleString('es-CO', { maximumFractionDigits: 0 }) + (moneda ? ` ${moneda}` : '')
          return (
            <>
              <Divider style={{ marginTop: 10, marginBottom: 10 }} />
              <Paper elevation={16}>
                <Card>
                  <CardContent>
                    <Typography gutterBottom variant="h6" component="div">
                      Resumen del rango
                    </Typography>
                    <Grid container spacing={2} sx={{ mt: 0.5 }}>
                      <Grid item xs={12} sm={6} md={3}>
                        <StatBox
                          icon={<CheckCircleOutlineRoundedIcon />}
                          color="#2E7DD7"
                          label="Cantidad de depósitos"
                          value={fmtCount(cantidad)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <StatBox
                          icon={<PaidRoundedIcon />}
                          color="#2E7D32"
                          label="Total billetero"
                          value={fmtMoneda(totalBilletero)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <StatBox
                          icon={<PaidRoundedIcon />}
                          color="#6A9E2C"
                          label="Total sobre"
                          value={fmtMoneda(totalSobre)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <StatBox
                          icon={<ReportProblemRoundedIcon />}
                          color="#D32F2F"
                          label="Rechazos"
                          value={fmtCount(rechazos)}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Paper>

              <Divider style={{ marginTop: 10, marginBottom: 10 }} />
              <Paper elevation={16}>
                <Card>
                  <CardContent>
                    <Typography gutterBottom variant="h6" component="div">
                      Tendencia por día (Billetero)
                    </Typography>
                    <Grid container spacing={3} sx={{ mt: 0.5 }}>
                      <Grid item xs={12} md={6}>
                        <LineChartSvg
                          title="Cantidad de depósitos por día"
                          labels={labels}
                          values={counts}
                          color="#2E7DD7"
                          valueFormatter={fmtCount}
                          integerOnly
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <LineChartSvg
                          title={`Valor total por día${moneda ? ` (${moneda})` : ''}`}
                          labels={labels}
                          values={totals}
                          color="#2E7D32"
                          valueFormatter={fmtMoneda}
                          yTickFormatter={formatCompact}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Paper>
            </>
          )
        })()}

        <Divider style={{"marginTop": 10, "marginBottom": 10}} />

        <Paper elevation={16}>
          <Card>
            <CardContent>
              <Typography gutterBottom variant="h6" component="div">
                Listado depositos:
              </Typography>
              <Divider style={{"marginTop": 10, "marginBottom": 10}} />
              { this.state.depositos.length > 0 &&
                <Button style={{"marginTop": 10, "marginBottom": 10}} variant='contained' onClick={this.exportExcel}>Exportar</Button>
              }
              <Box sx={{display: 'flex', flexWrap: 'wrap'}}>
                <DepositosTable depositos={this.state.depositos} />
              </Box>
            </CardContent>
          </Card>

        </Paper>

      </Box>

    )
  }
}

export default DepositosPage